import type { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { useDraggableAssetActivator } from '../contexts';

export const DraggableAssetActivator = ({ children }: PropsWithChildren) => {
  const { listeners, setNodeRef } = useDraggableAssetActivator();

  return (
    <ActivatorContainer {...listeners} ref={setNodeRef}>
      {children}
    </ActivatorContainer>
  );
};

const ActivatorContainer = styled.div`
  cursor: pointer;
`;
